module.exports = __webpack_public_path__ + "static/media/SE_Ordkjede.549fe5d6.mp4";